import { render, staticRenderFns } from "./flix.vue?vue&type=template&id=483417bc&scoped=true&"
import script from "./flix.vue?vue&type=script&lang=ts&"
export * from "./flix.vue?vue&type=script&lang=ts&"
import style0 from "./flix.vue?vue&type=style&index=0&id=483417bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483417bc",
  null
  
)

export default component.exports